// extracted by mini-css-extract-plugin
export var closeButton = "_12-1";
export var container = "_12-0";
export var fullModalImage = "_12-2";